/* global axios */
import ApiClient from '../ApiClient';

// T-122: quanto de cada estouro de SLA passou fora de casa, por parceiro.
class SlaRelatorioAPI extends ApiClient {
  constructor() {
    super('fandata/sla_relatorio', { accountScoped: true });
  }

  get({ since, until }) {
    return axios.get(this.url, { params: { since, until } });
  }
}

export default new SlaRelatorioAPI();
